class Menu {
    // initiate 
    constructor() {
        this.checkbox = document.getElementById("menu-checkbox");
        this.submenuLinks = document.querySelectorAll(".submenu-link");
        this.backButtons = document.querySelectorAll(".back-button");
        this.closeText = document.getElementById("close-text");
        this.menuText = document.getElementById("menu-text");
        this.backToTopButton = document.getElementById("back-to-top");
        this.events();
        this.overlay = document.querySelector('.overlay');
        this.overlayForeground = document.querySelector('.overlay__foreground');
        this.menuContainer = document.querySelector('.menu-container');
        this.isBackButtonClicked = false;
        this.scrollPosition = 0;
    }

    // events
    events() {
        this.checkbox.addEventListener("click", () => this.checkBoxDispatcher())
        document.addEventListener("keydown", e => this.keyPressDispatcher(e));
        document.addEventListener("click", (e) => this.clickDispatcher(e));
        document.addEventListener("DOMContentLoaded", () => this.postContentLoadedChecks())
        // Listen for clicks on submenu__link elements
        this.submenuLinks.forEach(link => {
            link.addEventListener("click", (e) => this.handleSubmenuClick(e));
        });
        // Listen for window resize to handle dynamic screen size changes
        window.addEventListener("resize", () => this.handleResize());
        // Listen for clicks on back button elements
        this.backButtons.forEach(button => {
            button.addEventListener("click", () => this.handleBackButtonClick());
        });
        this.closeText.addEventListener("click", () => this.closeOverlay());
        this.menuText.addEventListener("click", (e) => this.setMenuToggler(e));
        // show or hide back to top button
        window.addEventListener("scroll", () => this.handleScroll());
        this.backToTopButton.addEventListener("click", () => this.scrollToTop());
    }

    // methods
    keyPressDispatcher(e) {
        if (e.key === "Escape" && this.checkbox.checked) {
            this.closeOverlay();
        }
    }
    clickDispatcher(e) {
        const overlay = document.querySelector(".overlay");
        const overlayForeground = document.querySelector(".overlay__foreground");
    
        // Don't close if the click was on the checkbox or its label
        if (
            e.target === this.checkbox ||
            e.target.closest("label[for='menu-checkbox']") // if you use a label to toggle
        ) {
            return;
        }
    
        if (
            this.checkbox.checked &&
            overlay &&
            overlayForeground &&
            !overlayForeground.contains(e.target)
        ) {
            this.closeOverlay();
        }
    }
    
    checkBoxDispatcher() {
        if (this.checkbox.checked) {
            this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            // Lock the scroll visually and functionally
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollPosition}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%'; // prevent layout shift
        
            document.body.classList.add("no-scroll");
            document.querySelector(".checkbox-ctn").classList.add("overlay-open");
            document.getElementById('menu-cta').classList.add("noshow");
                       
        } else {
            this.closeOverlay();
        }
    }

    postContentLoadedChecks() {
        // adjust down if wpadminbar visible
        const adminBar = document.getElementById("wpadminbar");
        const nav = document.getElementById("nav-row");
       
        if (adminBar && nav) {
            const adminBarHeight = adminBar.offsetHeight;
            nav.style.marginTop = adminBarHeight + "px";
            // console.log(adminBarHeight);
            
        }
 
        // check to see if scrolled and change logo
        const mainNav = document.getElementById('main-nav'); // Get the element by ID

        window.addEventListener('scroll', function () {
            if (window.scrollY > 0) {
                // Add class when scrolled
                mainNav.classList.add('scrolled');
            } else {
                // Remove class when at the top
                mainNav.classList.remove('scrolled');
            }
        });

    }

    // Handle submenu link clicks
    handleSubmenuClick(event) {

        if (this.isBackButtonClicked) {
            // console.log('Click blocked after back button');
            this.isBackButtonClicked = false; // Reset flag
            return; // Prevent reopening after back button click
        }

        // Remove 'open' class from all submenu <ul> elements
        this.closeAllSubmenus();

         // Add 'open' class to the submenu <ul> within the clicked .submenu__link
        const submenu = event.target.closest(".submenu-link").querySelector(".submenu");
        if (submenu) {
             submenu.classList.add("open");
        }
    }

    handleResize() {
        // Optional: Remove 'noshow' class if screen size goes above 960px
        if (window.innerWidth >= 960) {
           // reset sub menu
          this.closeAllSubmenus();
        }
    }

    // Handle back button clicks
    handleBackButtonClick() {
        // Remove 'open' class from all submenu <ul> elements
        // reset sub menu
        this.closeAllSubmenus();

        this.isBackButtonClicked = true;
    }

    // method to close overlay
    closeOverlay() {
        this.checkbox.checked = false;
        // Unfreeze scroll visually
        const scrollToY = this.scrollPosition;
        document.body.style.top = '';
        document.body.style.position = '';

        document.body.classList.remove("no-scroll");
        document.querySelector(".checkbox-ctn").classList.remove("overlay-open");
        document.getElementById('menu-cta').classList.remove("noshow");
        this.closeAllSubmenus();

        // Scroll back manually after DOM updates settle
        requestAnimationFrame(() => {
            window.scrollTo(0, scrollToY);
        });

        // Uncheck only after transition completes
        const overlay = document.querySelector(".checkbox-ctn");
        const onTransitionEnd = () => {
            
            overlay.removeEventListener("transitionend", onTransitionEnd);
        };
        overlay.addEventListener("transitionend", onTransitionEnd);
    }
    

    // Method to close all submenus
    closeAllSubmenus() {
        this.submenuLinks.forEach(link => {
            const submenu = link.querySelector(".submenu");
            if (submenu) {
                submenu.classList.remove("open");
            }
        }); // re-show the get-in-touch button
    }

    // set menu toggler if "menu" text clicked on
    setMenuToggler(event) {
        event.preventDefault();
        event.stopPropagation();
        // const checkbox = document.querySelector('.menu-checkbox');
        if (this.checkbox) {
            this.checkbox.checked = true; // Set the checkbox to "checked"
            
            this.checkBoxDispatcher();
        }
    }

    // handle scrolling and hides button or shows
    handleScroll() {
        if (window.scrollY > 1100) {
            // alert("show");
            this.backToTopButton.classList.add('show');
          } else {
            this.backToTopButton.classList.remove('show');
          }
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

}

export default Menu